import type { ReactNode } from "react";
import type { ReviewCard as ReviewCardType } from "./reviewTypes";
import ReviewCardsColumn from "./ReviewCardsColumn";

export type ArticleHeaderWithReviewsProps = {
  title: string;
  figures?: ReactNode;
  cards: ReviewCardType[];
  onEdit?: (card: ReviewCardType) => void;
  onDelete?: (card: ReviewCardType) => void;
};

export function ArticleHeaderWithReviews({
  title,
  figures,
  cards,
  onEdit,
  onDelete,
}: ArticleHeaderWithReviewsProps) {
  if (cards.length === 0) {
    return (
      <>
        <h1 className="text-4xl font-semibold leading-tight text-black md:text-5xl">
          {title}
        </h1>
        {figures ? <div className="flex flex-col gap-6">{figures}</div> : null}
      </>
    );
  }

  return (
    <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-start">
      <div>
        <h1 className="text-4xl font-semibold leading-tight text-black md:text-5xl">
          {title}
        </h1>
        {figures ? <div className="mt-6 flex flex-col gap-6">{figures}</div> : null}
      </div>
      <div className="space-y-4 lg:sticky lg:top-6">
        <ReviewCardsColumn cards={cards} onEdit={onEdit} onDelete={onDelete} />
      </div>
    </div>
  );
}

export default ArticleHeaderWithReviews;
